import { Navigate } from '@sorare/routing';
import { ANY_SPORT_LINEUPS_PRO } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const Lineups = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_LINEUPS_PRO)}
      replace
      keepSearchParams
    />
  );
};

export default Lineups;
